import { render, staticRenderFns } from "./Products-sales.vue?vue&type=template&id=6bf6ad60"
import script from "./Products-sales.vue?vue&type=script&lang=js"
export * from "./Products-sales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports